import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { AddTransactionVM } from '../../Structure/ViewModels/Trainee/AddTransactionVM'
import { TraineeSubscription } from '../../Structure/Models/Trainee'
import { Value } from 'sass'
import CustomSelect from '../Utilities/CustomSelect'
import { mainPath } from '../../Structure/Constants/MainPath'
import CustomImageUpload from '../Utilities/CustomImageUpload'
import { Router } from '../../Structure/Handlers/Router'
import Profile from './Profile'

const AddTransaction = (props:{subscription:TraineeSubscription , id:string , name:string}) => {
    const [vm, setVm] = useState<{viewModel:AddTransactionVM}>({viewModel: new AddTransactionVM(props.subscription , props.id , props.name)})
    const control = vm.viewModel
    useEffect(()=>control.subscribeUpdate(setVm) , [])

  return (
    <div className='p-0 m-0'>
    {
        control.Show(
        <Container>
          <Row className='py-5'>
          <h3 className='fw-bold text-center txt-color-I'>اضافة تحويل</h3>
          </Row>
          <Row className='pb-5'>
          <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
          <Row  className='w-100'>
              <Col md={12} className='d-flex justify-content-around'>
                  <label  className='my-auto py-2 py-md-0'>الاسم</label>
                  <label  className='my-auto py-2 py-md-0 txt-color-I fw-bold'>{control.Name}</label>
              </Col>
          </Row>
            </Col>
            <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
              <Row  className='w-100'>
                  <Col md={12} className='d-flex justify-content-around'>
                      <label  className='my-auto py-2 py-md-0'>المطلوب</label>
                      <label  className='my-auto py-2 py-md-0 txt-color-I fw-bold'>{control.Deserved}</label>
                  </Col>
              </Row>
            </Col>
            </Row>
            <Row className='pb-5'>
              <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                <Row  className='w-100'>
                  <Col md={12} className='d-flex justify-content-around'>
                    <label className='my-auto py-2 py-md-0'>سعر العملة</label>
                    <label className='my-auto py-2 py-md-0 txt-color-I fw-bold'>{control.CurrencyPrice}</label>
                  </Col>
                </Row>
              </Col>
              <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                <Row  className='w-100'>
                  <Col md={12} className='d-flex justify-content-around'>
                    <label className='my-auto py-2 py-md-0'>السعر المحلى</label>
                    <label className='my-auto py-2 py-md-0 txt-color-I fw-bold'>
                      {
                        control.LocalPrice
                      }
                    </label>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='border p-3'>
              <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                <Row  className='w-100'>
                    <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                        <label htmlFor="marketier" className='my-auto py-2 py-md-0'>نوع الحساب</label>
                    </Col>
                    <Col md={8}>
                      <CustomSelect list={control.Accounts.map(i=>({label:i.name , value:i.id}))} selected={control.Data.account_id} onSelect={a=>control.AccountId=a} />
                    </Col>
                </Row>
              </Col>
              {
                (control.Data?.verification)===null?(null):(
                  <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                  <Row  className='w-100'>
                    <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                      <label htmlFor="marketier" className='my-auto py-2 py-md-0'>التوثيق</label>
                    </Col>
                    <Col md={8}>
                      <CustomSelect list={[{label:'توثيق', value:'verify'} , {label:'بدون توثيق' , value:'no verify'}]} selected={control.Data.verification} onSelect={a=>control.Verification=a} />
                    </Col>
                  </Row>
                </Col>
                )
              }
              <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                <Row className='w-100'>
                    <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                        <label htmlFor="remained" className='my-auto py-2 py-md-0'>المدفوع</label>
                    </Col>
                    <Col md={8}>
                        <input id='remained' type="text" className='w-100 input-field' value={control.Data.paid} onChange={a=>control.Paid=a.target.value} placeholder='المدفوع...' />
                    </Col>
                </Row>
              </Col>
              <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                <Row className='w-100'>
                    <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                        <label htmlFor="remained" className='my-auto py-2 py-md-0'>مبلغ اضافى</label>
                    </Col>
                    <Col md={8}>
                        <input type="text" className='w-100 input-field' value={control.Data.additional} onChange={(a)=>control.Additional=a.target.value} placeholder='مبلغ اضافى...' />
                    </Col>
                </Row>
              </Col>
              <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                <Row className='w-100'>
                    <Col md={4} className='d-flex justify-content-center justify-content-md-start'>
                        <label htmlFor="remained" className='my-auto py-2 py-md-0'>تاريخ التحويل</label>
                    </Col>
                    <Col md={8} className='d-flex'>
                        <input id='remained' type="date" className='w-100 input-field text-center my-auto' onChange={a=>control.Date=a.target.value} />
                    </Col>
                </Row>
              </Col>
              <Col lg={6} className='d-flex justify-content-between px-3 py-3'>
                <Row className='w-100'>
                    <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                        <label htmlFor="remained" className='my-auto py-2 py-md-0'>صورة الايصال</label>
                    </Col>
                    <Col md={8}>
                        <CustomImageUpload clear={a=>control.ClearImg=a} onSelect={a=>control.Image=a}/>
                    </Col>
                </Row>
              </Col>
              <Col lg={6} className='d-flex justify-content-between px-3 py-3 pt-5'>
                <Row className='w-100'>
                    <Col md={4} className='d-flex justify-content-center justify-content-md-start h'>
                        <label htmlFor="remained" className='my-auto py-2 py-md-0 '>ملاحظات</label>
                    </Col>
                    <Col md={8}>
                        <textarea 
                          placeholder='ملاحظات'
                           onChange={a=>control.Notes = a.target.value} className="input-field w-100 "
                            style={{height:'100%', resize:'none'}} 
                          />
                    </Col>
                </Row>
              </Col>
              <Row className=' justify-content-center pt-3'>
                    <Col lg={12} className='d-flex justify-content-center px-3 py-3 pt-5'>
                        <button className='button-I btn-cl-I mx-3 p-1 px-5 fs-5 ' onClick={()=>Router.OpenNormalPage(<Profile id={control.Id}/>)}>رجوع</button>
                        <button className='button-I btn-cl-I mx-3 p-1 px-5 fs-5 ' onClick={()=>control.send()}>تسجيل</button>
                    </Col>
                </Row>
          </Row>
        </Container>)
    }
    </div>
  )
}

export default AddTransaction
